<script lang="ts">
  import Label from '$provider/constants/Label';

  interface Props {
    label: string;
    onclickedit?: () => void;
  }

  let { label, onclickedit }: Props = $props();

  let reviewLabel = $derived(label || 'Unknown value');

  const onClick = (e: MouseEvent): void => {
    e.stopPropagation();
    onclickedit?.();
  };
</script>

<div data-cy="resolved-unknown-item-label" class="comp-resolved-unknown-value-type">
  Resolved: Needs Review - {reviewLabel} (<button
    data-cy="edit-btn"
    class="action"
    onclick={onClick}
  >
    {Label.Edit}
  </button>)
</div>

<style>
  .comp-resolved-unknown-value-type {
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-dark);
    font-style: italic;
  }
  .action {
    color: var(--blue);
  }
</style>
